import { Button} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Modal, { SimpleModalControls } from "../../components/Modal";
import { FaTrash } from "react-icons/fa";
import { BiLinkExternal } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import {useState} from "react"
import { getAxiosInstance } from "../../utils/axiosInstance";
import axios from "axios";
import { toast } from "react-toastify";


interface ProductProviderProps extends SimpleModalControls{
    providerId: string,
    productId : string
}


const ModalProductProvider = (props: ProductProviderProps) => {
    const { t } = useTranslation("translations");
    const nav = useNavigate();
    const [isDeleting, setIsDeleting] = useState<boolean>(false);

    const deleteProductProvider = async() => {
        try{
            const res = await getAxiosInstance().delete(`/productProviders`, {
                data: {
                productId: props.productId,
                providerId: props.providerId
                }
            })

            if(res.status === 200){
                toast.success("Deleted the provider from product", {position: toast.POSITION.BOTTOM_RIGHT});
                props.onClose();
            }
        }catch(error){
            if (axios.isAxiosError(error)) {
                toast.error(`${error.response?.data}`, { position: toast.POSITION.BOTTOM_RIGHT })
            } else {
                toast.error(`Could not retrieve the product from the database ${error}`, { position: toast.POSITION.BOTTOM_RIGHT });
            } 
        }
    }

    return(
        <>
           <Modal
            header={t("Provider")}
            onClose={props.onClose}
            isOpen={props.isOpen}
            >
            <div className="w-full"> 
                {/* <Button
                colorScheme='red'
                className="w-full"
                isLoading={isDeleting}
                loadingText={t("DELETING_PROVIDER")}
                leftIcon={<FaTrash />}
                onClick={() => { deleteProductProvider()}}
                >
                {t("DELETE_PROVIDER")}
                </Button> */}
                <Button
                colorScheme='green'
                className="w-full mt-5"
                leftIcon={<BiLinkExternal />}
                onClick={() => nav(`/provider`)}
                >
                {t("GO_TO_PROVIDER_PAGE")}
                </Button>
            </div>
            </Modal> 
        </>
    )
}

export default ModalProductProvider; 